import { getAttrValue, isBoolean } from '@grandvisionhq/utils';

const getAllowBackOrder = (variant)=>{
    const allowBackOrder = getAttrValue(variant, 'allowBackOrder');
    return isBoolean(allowBackOrder) ? allowBackOrder : undefined;
};

export { getAllowBackOrder };
//# sourceMappingURL=get-allow-back-order.js.map
